export enum RatesOrderEnum {
  Asc = 'asc',
  Desc = 'desc'
}
